/**
 * informe-editor-steps.ts — wizard step arrays per informe type.
 *
 * Exported as constants so they can be imported in tests and InformeEditor.
 * REQ-8a: IS steps do NOT include "Antecedentes" (S-8a.1).
 */
import type { TipoInforme } from "../types.js";

export const IE_PASOS = [
  "Datos generales",
  "Equipos",
  "Panel fotográfico",
  "Problemas",
] as const;

export const IS_PASOS = [
  "Datos generales",
  "Equipos",
  "Panel fotográfico",
  "Actividades",
  "Conclusiones",
  "Servicio",
] as const;

export const AC_PASOS = [
  "Datos generales",
  "Equipos",
  "Actividades",
  "Conclusiones",
  "Firmas",
] as const;

// ponytail: PASOS_POR_TIPO stays as readonly string[] to match InformeEditor usage
export const PASOS_POR_TIPO: Record<TipoInforme, readonly string[]> = {
  IE: IE_PASOS,
  IS: IS_PASOS,
  AC: AC_PASOS,
};
